import { pwaStyleAdapter } from '../../../web/src/utils/mobileSupported';
export var height = pwaStyleAdapter(5, 'rem');